import {Injectable} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import { RxStompService } from '@stomp/ng2-stompjs';
import {combineLatest, Observable, of} from 'rxjs';
import {catchError, mergeMap, tap} from 'rxjs/operators';
import {FabricService} from 'src/app/services/fabric/fabric.service';
import {NotificationsService} from '../api/notifications.service';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  constructor(private translocoService: TranslocoService,
              private authService: AuthService,
              private fabricService: FabricService,
              private notificationsService: NotificationsService) {
  }

  init(): Observable<any> {
    // TODO: Register icons
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    let initializer;
    if (code) {
      initializer = this.fabricService.performNoPopUpLogin()
        .pipe(mergeMap(() => this.fabricService.initialize(true)));
    } else {
      initializer = this.fabricService.initialize()
        .pipe(mergeMap(() => this.authService.login()));
    }

    return initializer
      .pipe(
        tap(() => {
          // this.notificationsService.initialize();
          // Remove code Url query param
          const locationHref = `${window.location.origin}${window.location.pathname}`;
          window.history.replaceState(null, null, locationHref);
        }),
        mergeMap(() => combineLatest([this.translocoService.load('en'), this.authService.loadPrincipal().pipe(
          catchError(() => {
            return of(-1);
          }))
        ])),
      );
  }
}
